// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"66a2272c","81":"68933db1","100":"ee1f8991","153":"389952c3","763":"5ddacf6d","887":"16e7435b"}[chunkId] + ".chunk.js";
};